import Loading from "./Loading";

const AuthCallback = () => <Loading />;

export default AuthCallback;
